
const host_state = (require('./status')).status  //true为正式，false为测试

// 测试接口
let host = 'https://advertising.52shanglu.com';
let uploadUrl = 'https://changqin-advertisement.oss-cn-zhangjiakou.aliyuncs.com'

if(host_state){
    // 正式接口
    host = 'https://advertising.changqinos.com';
}

export default {
    host,
    uploadUrl,
    host_state
}